import './index.scss';

const LoadingDots = () => (
  <div className="tw-flex tw-items-center tw-gap-1">
    <div className="dot dot-1" />
    <div className="dot dot-2" />
    <div className="dot dot-3" />
  </div>
);

export default LoadingDots;
